import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacilityListItem = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 14 14",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#facility-list-item)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.2,
				d: "M7.844 5.33h4.01v5.714h-4.01V5.329Z"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 1.604,
				height: .667,
				x: 9.047,
				y: 6.554,
				fill: "currentColor",
				rx: .333
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.2,
				d: "M2.229 3.044h5.614v8H2.229v-8Z"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 2.246,
				height: .667,
				x: 3.914,
				y: 4.758,
				fill: "currentColor",
				rx: .333
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.2,
				d: "M1.668 11.044h10.667"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "facility-list-item",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M.334.377h13.333V13.71H.334z"
		})
	}) })]
});
export default SvgFacilityListItem;
